import React, { useEffect, useState } from "react";
import { Box, TableCell, TableHead, TableRow, TableSortLabel, Tooltip, Typography, styled, tooltipClasses } from "@mui/material";
import { useQualityData } from "../../context/QualityDataContext";
import { visuallyHidden } from "@mui/utils";

const headerCellStyle1 = {
  fontSize: "12px",
  borderLeft: "1px solid #c4c4c4",
  py: 1,
  backgroundColor: "#D9D9D9",
};
const headerCellStyle2 = {
  fontSize: "12px",
  borderLeft: "1px solid #d4d4d4",
  py: 1,
  backgroundColor: "#ececec",
};

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0px 3px 6px #0000001F",
    zIndex: "1",
  },
}));

const DescTooltip = ({ children, data, placement = "right" }) => {
  return (
    <LightTooltip
      title={
        <div
          style={{
            backgroundColor: "#ECECEC",
            color: "#000",
            margin: "-5px -8px",
            boxShadow: "none",
            borderRadius: "5px",
            fontSize: "13px",
            fontWeight: "600",
            padding: "8px 18px",
          }}
        >
          {data}
        </div>
      }
      placement={placement}
    >
      {children}
    </LightTooltip>
  );
};

function NestedTableHead({ columns,order,setOrder }) {
  const [firstRow, secondRow] = columns;
  const [orderBy, setOrderBy] = useState("");

  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // useEffect(()=>{
  //   console.log("order",order)
  //   console.log("orderBy", orderBy);
  // },[order,orderBy])

  return (
    <TableHead>
      <>
        <TableRow>
          {firstRow.map((column, index) => (
            <TableCell
              key={index}
              sx={{
                ...headerCellStyle1,
                ...(index === 0 ? { borderLeft: "none" } : {}),
                textAlign: index === firstRow.length - 1 ? "center" : null,
              }}
              colSpan={column.colSpan}
            >
              {column?.title === "Timestamp" ? (
                <TableSortLabel
                  active={orderBy === column?.title}
                  direction={orderBy === column?.title ? order : "asc"}
                  onClick={createSortHandler(column?.title)}
                >
                  {column?.label ? (
                    <DescTooltip data={column?.label} placement="top">
                      <Typography fontSize={12} fontWeight={600}>
                        {column?.title}
                      </Typography>
                    </DescTooltip>
                  ) : (
                    <Typography fontSize={12} fontWeight={600}>
                      {column?.title}
                    </Typography>
                  )}
                  {orderBy === column?.title ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : column?.label ? (
                <DescTooltip data={column?.label} placement="top">
                  <Typography fontSize={12} fontWeight={600}>
                    {column?.title}
                  </Typography>
                </DescTooltip>
              ) : (
                <Typography fontSize={12} fontWeight={600}>
                  {column?.title}
                </Typography>
              )}
              {/* {column.label} */}
            </TableCell>
          ))}
        </TableRow>
        {secondRow.length>5 &&
        <TableRow>
          {secondRow?.map((column, index) => (
            <TableCell
              key={index}
              sx={{
                ...headerCellStyle2,
                ...(index === 0 ? { borderLeft: "none" } : {}),
              }}
            >
              {column?.label ? (
                <DescTooltip data={column?.label} placement="top">
                  <Typography fontSize={12} fontWeight={600}>
                    {column?.title}
                  </Typography>
                </DescTooltip>
              ) : (
                <Typography fontSize={12} fontWeight={600}>
                  {column?.title}
                </Typography>
              )}
              {/* {column.label} */}
            </TableCell>
          ))}
        </TableRow>
}
      </>
    </TableHead>
  );
}

export default NestedTableHead;
